// extracted by css-extract-rspack-plugin
export default {"colorGray4":"#5e5e5e","root":"csv-modal__root___cUyfv common__box___P1CnO","title":"csv-modal__title___MgutC common__title___XK36o common__serif___NRm4K common__bold___ve4Qa"};